import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="sp-empty" style={{ marginTop: 120 }}>
      <div style={{ fontSize: 18, marginBottom: 8 }}>404</div>
      {/* Resolve to the caller's role home (customer → /research), not a
          hardcoded /dashboard a customer can't see. */}
      <Link to="/">Back to home</Link>
    </div>
  );
}
